import validate from "validate.js";
import React from "react";
import { FormattedMessage, defineMessages } from "react-intl";

const messages = defineMessages({
  presenceValidator: {
    id: "app.input.pressence",
    description: "ticker valdiation text",
    defaultMessage: "Can't be Blank",
  },
  autocompleteValidator: {
    id: "app.input.pressence",
    description: "ticker valdiation text",
    defaultMessage: "Can't be Blank",
  },
  numberValidator: {
    id: "app.input.number",
    description: "number validation text",
    defaultMessage: "Is not a number",
  },
  integerValidator: {
    id: "app.input.integer",
    description: "number validation text",
    defaultMessage: "Is not an integer",
  },
  greaterThanZeroValidator: {
    id: "app.input.greaterThanZero",
    description: "greater than zero validation text",
    defaultMessage: "Must be greater than 0",
  },
  phoneValidator: {
    id: "app.input.phone",
    description: "phone validation text",
    defaultMessage: "Phone is invalid",
  },
  emailValidator: {
    id: "app.input.email",
    description: "email validation text",
    defaultMessage: "Email is invalid",
  },
});

validate.validators.duration = function (value, options, key, attributes) {
  if (value && value.chronoUnit && !isNaN(value.duration)) {
    return null;
  }
  return "is invalid";
};

validate.validators.autocompleteOption = function (value, options, key, attributes) {
  if (value && value.value !== undefined && value.value !== "" && value.value != null) {
    return null;
  }
  return <FormattedMessage {...messages.autocompleteValidator} />;
};

validate.validators.compare = function (value, options, key, attributes, formValuesContainer) {
  return options.than.map(field => {
    let relatedFieldValue;
    if (field.includes(".")) {
      const arr = field.split(".");
      let result = formValuesContainer.formValues;
      arr.forEach(it => {
        result = result[it];
      });
      relatedFieldValue = result;
    } else {
      relatedFieldValue = formValuesContainer.formValues[field];
    }

    const errorMessage = options.message || "is invalid with respect to " + field;
    if (!value || !relatedFieldValue) {
      return null;
    }
    switch (options.valueType) {
      case "number":
        value = parseInt(value);
        relatedFieldValue = parseInt(relatedFieldValue);
        break;
      case "date":
        value = new Date(value).getTime();
        relatedFieldValue = new Date(relatedFieldValue).getTime();
        break;
      default:
        break;
    }

    if (value && relatedFieldValue) {
      switch (options.logic) {
        case "isGreater":
          return value > relatedFieldValue ? null : errorMessage;
        case "isLesser":
          return value < relatedFieldValue ? null : errorMessage;
        default:
          return null;
      }
    }
    return null;
  });
};

validate.validators.emailList = function (value) {
  if (value && typeof value === "string") {
    const val = value.split(",");
    if (
      val.some(
        vl =>
          !/^[a-zA-Z0-9_+&*-]+(?:\.[a-zA-Z0-9_+&*-]+)*@(?:[a-zA-Z0-9-]+\.)+[a-zA-Z]{2,10}$/.test(
            vl.trim()
          )
      )
    ) {
      return <FormattedMessage {...messages.emailValidator} />;
    }
  }
};

validate.validators.videoLink = function (value, options) {
  let isValid = false;
  switch (options) {
    case "YouTube":
      const regExp = /^(http(s)?:\/\/)?((w){3}.)?youtu(be|.be)?(\.com)?\/.+/;
      isValid = !!value.match(regExp);
      break;
    default:
      break;
  }
  return !isValid ? "is invalid" : null;
};

validate.validators.phone = function (value) {
  if (value && typeof value === "string") {
    if (!/^[+]*[(]?[-\s0-9]{1,7}[)]?[-\s/0-9]*$/.test(value)) {
      return <FormattedMessage {...messages.phoneValidator} />;
    }
  }
};

validate.validators.number = function (value) {
  if (value && typeof value === "string") {
    if (!/^\d+$/.test(value)) {
      return <FormattedMessage {...messages.numberValidator} />;
    }
  }
};

function filterValidateErros({ validationResult, errors }) {
  Object.keys(validationResult).forEach(key => {
    const validationResultValues = validationResult[key].filter(v => v);
    if (validationResultValues.length) {
      errors = { ...errors, [key]: validationResultValues };
    }
  });
  return errors;
}

export function validateFields({ fields, validationConfig, formValues, translationConfig }) {
  let errors = {};
  if (validationConfig && fields && fields.length > 0) {
    fields.forEach(({ fieldName, translated }) => {
      if (!validationConfig[fieldName] || !validationConfig[fieldName].constraints) {
        return;
      }

      if (validationConfig[fieldName].constraints) {
        if (
          validationConfig[fieldName].constraints.presence &&
          validationConfig[fieldName].constraints.presence.allowEmpty === false
        ) {
          validationConfig[fieldName].constraints.presence.message = (
            <FormattedMessage {...messages.presenceValidator} />
          );
        }
        if (
          validationConfig[fieldName].constraints.numericality &&
          !validationConfig[fieldName].constraints.numericality.message
        ) {
          if (
            validationConfig[fieldName].constraints.numericality.greaterThan !== undefined &&
            formValues[fieldName] !== undefined &&
            formValues[fieldName] !== null &&
            formValues[fieldName] !== "" &&
            Number(formValues[fieldName]) <=
              validationConfig[fieldName].constraints.numericality.greaterThan
          ) {
            validationConfig[fieldName].constraints.numericality.message = (
              <FormattedMessage {...messages.greaterThanZeroValidator} />
            );
          } else if (validationConfig[fieldName].constraints.numericality.onlyInteger) {
            validationConfig[fieldName].constraints.numericality.message = (
              <FormattedMessage {...messages.integerValidator} />
            );
          } else {
            validationConfig[fieldName].constraints.numericality.message = (
              <FormattedMessage {...messages.numberValidator} />
            );
          }
        }
      }
      if (translated) {
        const translationField = translationConfig.fieldName;
        if (formValues[translationField] && formValues[translationField].length > 0) {
          formValues[translationField].forEach(translation => {
            let validationResult = validate(
              { [fieldName]: translation[fieldName] },
              { [fieldName]: validationConfig[fieldName].constraints },
              { formValues }
            );
            if (validationResult) {
              if (!errors[translationField]) {
                errors[translationField] = {};
              }
              if (!errors[translationField][translation.locale]) {
                errors[translationField][translation.locale] = {};
              }

              errors[translationField][translation.locale][fieldName] = validationResult[fieldName];
            }
          });
        }
      } else {
        let validationResult;
        if (fieldName.includes(".")) {
          const arr = fieldName.split(".");
          let result = formValues;
          arr.forEach(it => {
            result = result[it];
          });

          validationResult = validate(
            { [arr[0]]: result },
            { [arr[0]]: validationConfig[fieldName].constraints },
            { formValues }
          );
        } else {
          validationResult = validate(
            { [fieldName]: formValues[fieldName] },
            { [fieldName]: validationConfig[fieldName].constraints },
            { formValues }
          );
        }

        if (validationResult) {
          errors = filterValidateErros({ validationResult, errors });
        }
      }
    });
  }

  return errors;
}
